import React from "react";
import { motion } from "framer-motion";

import Login from "../../components/login/login.component";
import Register from "../../components/register/register.component.class";
import Box from "../../components/retro/box/box.component";

import "../sign-in/sign-in.styles.scss";

import { BsChevronCompactDown, BsChevronCompactUp } from "react-icons/bs";

class SignUp extends React.Component {
  constructor() {
    super();
    this.state = {
      yPos: 0,
    };
  }

  render() {
    return (
      <div className="signIn">
        <Box style={{ padding: "0px" }}>
          <div className="signIn__content">
            <motion.div
              className="signIn__scroll"
              animate={{ y: this.state.yPos }}
              transition={{ duration: 0.7, type: "spring" }}
            >
              <div className="signIn__login-content">
                <Register />
                <div className="signIn__noAccount">
                  <motion.p
                    whileHover={{ scale: 1.04 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => this.setState({ yPos: -400 })}
                  >
                    Already a member? <span>Login!</span>
                    <br />
                    <BsChevronCompactDown size="1.5em" />
                  </motion.p>
                </div>
              </div>
              <div className="signIn__register-content">
                <Login />
                <div className="signIn__noAccount">
                  <motion.p
                    whileHover={{ scale: 1.04 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => this.setState({ yPos: 0 })}
                  >
                    Don't have an account? <span>Register!</span>
                    <br />
                    <BsChevronCompactUp size="1.5em" />
                  </motion.p>
                </div>
              </div>
            </motion.div>
          </div>
        </Box>
      </div>
    );
  }
}

export default SignUp;
